// extracted by mini-css-extract-plugin
module.exports = {"tableHeadtext":"ExpirationDContent_tableHeadtext__X_K9C"};